export default {
    genericTitle: 'Error',
    genericMessage: 'An error occurred. Please try again later.',
    configurationUnavailableTitle: 'Settings could not be loaded',
    configurationUnavailableMessage:
        "We couldn't reach the server to find out which features your organization uses. Nothing is switched off — try again in a moment.",
    retry: 'Try again',
    profileAccessUnavailableTitle: 'This profile could not be opened',
    profileAccessUnavailableMessage:
        "We couldn't reach the server to find out what you are allowed to see. Your access has not changed — try again in a moment.",
    transcriptEmptyFile: 'The selected file is empty. Please choose a transcript containing text.',
    transcriptFileTooLarge: 'The transcript must be 10 MB or smaller.',
    transcriptUnsupportedFormat: 'Please upload a .txt or .md file.',
    transcriptUnsupportedContentType: 'Please upload a plain text or markdown file.',
    transcriptUnreadableContent:
        "This file can't be read as text. Save the transcript as plain text (.txt), then try again.",
    insufficientPermissionsTitle: 'Insufficient permissions',
    insufficientPermissionsMessage:
        'You do not have the permissions required to view this content or complete this action. Contact your administrator if you believe this is a mistake.',
    notFoundOrInaccessibleTitle: 'Item not found',
    notFoundOrInaccessibleMessage: "This item can't be found or you don't have access to it.",
    pageNotFoundTitle: 'Page not found',
    pageNotFoundMessage:
        'This address leads nowhere. The link may be outdated, or the page may have moved.',
    noReviewerResponses:
        'None of the reviewers have responded yet. Come back later to see the results',
    noEvaluationInPeriod:
        'No evaluations match the selected time period. Please try selecting a different date range or check back later when results are available.',
    CycleEvaluationRelaunchCooldownError:
        'This feedback cycle was already processed within the last 24 hours. Please wait before relaunching.',
    CycleEvaluationInvalidStepError:
        'Cannot activate the feedback cycle until all mandatory steps are completed.',
    CycleInstanceInvalidStepError:
        'Cannot launch the cycle instance until all mandatory steps are completed.',
    CompetencyGroupAlreadyImportedError: 'This competency group has already been imported.',
    CompanyValueMaxLimitError: 'Maximum of 8 company values allowed.',
    CompanyValueDuplicateNameError: 'A company value with this name already exists.',
    CompletedManagerAssessmentCannotModify:
        'This {{managerLabel}} assessment has already been completed. Historical results cannot be modified.',
    SubmittedManagerAssessmentSetupCannotModify:
        'This {{managerLabel}} assessment has already been submitted. Its competencies, company values and template can no longer be changed.',
    CycleEvaluationMissingLaunchDateError:
        'This feedback cycle cannot be launched without a launch date. Set a launch date and try again.',
    CycleEvaluationCannotDeactivateAfterLaunchError:
        'This feedback cycle has already generated evaluations and can no longer be deactivated.',
    CycleEvaluationLaunchDateAlreadyReachedError:
        'This feedback cycle has already started. Its launch date can no longer be changed.',
    CycleEvaluationGroupDerivedStatusError:
        'The completed status is set automatically once every evaluation in the cycle is finished. It cannot be set directly.',
    CycleEvaluationGroupCannotLeaveDraftError:
        'A feedback cycle cannot be returned to draft once it has left that status.',
    CycleEvaluationGroupDraftCannotBeDeactivatedError:
        'A draft feedback cycle cannot be deactivated because it has not been launched yet.',
    CompletedCycleEvaluationGroupCannotModify:
        'This feedback cycle has already been completed. Completed cycles cannot be modified.',
    CycleEvaluationGroupNotActiveCannotApplyError:
        'Changes can only be applied to a feedback cycle that is currently running. Launch or reactivate the cycle first.',
    ObjectivePillarRequiredError:
        'Your organization requires a strategic pillar for every published objective. Choose one, then try again.',
    ObjectivePeriodDuplicateNameError: 'An objective period with this name already exists.',
    ObjectivePeriodInvalidStatusTransitionError:
        'This status change is not allowed for this objective period.',
    CompletedObjectivePeriodCannotModify:
        'This objective period has already been completed. Completed periods cannot be modified.',
    CompetencyProfileInactiveError:
        'This competency profile is deactivated and cannot be edited. Reactivate the profile or unassign it from the employee first.',
    CompetencyProfileNotFoundError:
        'The competency profile assigned to this employee no longer exists. Assign an active profile, then try again.',
    MeetingLinkNotFoundError: 'The linked meeting cannot be found for this employee.',
    MeetingLinkNotACareerMeetingError: 'Only a career aspirations meeting can hold this record.',
    EmployeeNoteAssessmentLinkError:
        'This note can only be written under a question of the {{managerLabel}} assessment you are completing for this employee.',
    CareerStepKindAlreadyTakenError:
        'This employee already has a step of this kind. Edit the existing step instead.',
    CareerAspirationMeetingAlreadyRecordedError:
        'Career aspirations have already been recorded for this meeting.',
    EmployeeNoteQuestionAlreadyHasNoteError:
        'This question already has a note. Edit that note instead.',
    EmployeeNoteContentRequiredError: 'The note is empty. Write some text, then try again.',
    EmployeeNoteContentTooLongError: 'The note is too long. Shorten it, then try again.',
    CompletedThematicMeetingCannotModify:
        'This meeting is completed and can no longer be changed. Reopen it first.',
    ThematicMeetingNotPlannedCannotComplete: 'Only a planned meeting can be marked as completed.',
    ThematicMeetingNotCompletedCannotReopen: 'Only a completed meeting can be reopened.',
    ThematicMeetingCalendarMissingDateError:
        'This meeting has no date yet. Choose a date before adding it to your calendar.',
    ThematicMeetingTopicHasNoTemplateError: 'This plan is no longer offered. Pick another one.',
    CompensationLockedAmountAboveCapError:
        'A locked amount exceeds the individual increase ceiling: lower it or unlock the row.',
    FeedbackPrivacyLockedAfterLaunchError:
        'Whether feedback is anonymous or named can no longer change once it has been launched.',
    FeedbackPrivacyFollowsTheCycleError:
        "This 360 feedback follows its cycle's anonymous or named setting: it cannot be changed for this feedback alone.",
    AnonymousFeedbackTooFewRespondentsError:
        'Anonymous feedback needs at least {{anonymousFeedbackMinimumResponses}} respondents: with fewer, the answers would reveal who responded.',
    AnonymousFeedbackRespondentRemovalError:
        'A respondent can no longer be removed from anonymous feedback once it has been launched.',
    FeedbackRespondentAddedOnceOverError:
        'This 360 feedback is over: respondents can no longer be added.',
    AnonymousFeedbackOnlyFor360Error:
        'Only 360 feedback can be anonymous: no other evaluation has enough respondents for its results to ever be shown.',
    CommentRepliesFollowTheCycleError:
        "This 360 feedback follows its cycle's setting for replies to comments: it cannot be changed for this feedback alone.",
    CommentRepliesLockedOnceCompletedError:
        'This 360 feedback is over: its setting for replies to comments can no longer be changed.',
};
